import { useI18n } from '@/shared/i18n';
import { StatusBadge } from './StatusBadge';

export function TransactionDirectionBadge({ direction }: { direction: 'Debit' | 'Credit' | string }) {
  const { t } = useI18n();
  return direction === 'Credit'
    ? <StatusBadge label={t('common.direction.credit')} tone="success" />
    : <StatusBadge label={t('common.direction.debit')} tone="warning" />;
}
